module.exports = __webpack_public_path__ + "static/img/gzzShade2.405f043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gzzShade2.png
// module id = mHXV
// module chunks = 2